import {
  APP_API_KEY,
  BASE_IMAGES_URL,
  INSTANCE_URL,
  itemCount,
} from "Constants";

import { showLoading, hideLoading } from "react-redux-loading-bar";
import { isEmpty } from "ActionsSpeakers";
import { getHeaders } from "CommonUtils";

import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  patchRequest,
  uploadEncodedFile,
} from "NetworkCall";

import _ from "lodash";

import axios from "axios";
import axiosFileupload from "axios-fileupload";

import { randomstring } from "randomstring-js";

export var DELETE_NEWS_SUCESS = "DELETE_NEWS_SUCESS";
export var DELETE_NEWS_ERROR = "DELETE_NEWS_ERROR";
export var INSERT_NEWS = "INSERT_NEWS";
export var FETCH_NEWS = "FETCH_NEWS";
export var LOAD_EDIT_NEWS_DATA = "LOAD_EDIT_NEWS_DATA";
export var OPEN_NEWS_MODAL = "OPEN_NEWS_MODAL";
export var NEWS_SEARCH = "NEWS_SEARCH";
export var UPDATE_NEWS_IMAGE = "UPDATE_NEWS_IMAGE";

export function fetchNews(session, search = "", pageCount = 0, callback) {
  var offset = pageCount * itemCount;
  var offSetQuery = `limit=${itemCount}&offset=${offset}&`;
  if (search !== "") {
    offSetQuery = "";
  }
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/news?${offSetQuery}include_count=true&filter=eventid=${session.eventid}&order=featured%20DESC%2C%20createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        var resultData = [];
        data.resource.map((newsitem) => {
          if (
            newsitem.newstitle.toLowerCase().indexOf(search.toLowerCase()) !==
            -1
          ) {
            resultData.push(newsitem);
          }
        });
        dispatch({
          type: FETCH_NEWS,
          payload: { data: resultData, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function deleteNewsItem(session, newsitemid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/news/${newsitemid}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
        dispatch(fetchNews(session, "", "", (callback) => {}));
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function isimportant(session, newsitem, value, callback) {
  let body = { featured: value };
  let data = { resource: body };
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (newsid=${newsitem.newsid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/news?filter=(${filter})`;
  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
        dispatch(fetchNews(session, "", "", (callback) => {}));
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function loadNewsItem(newsitem) {
  return {
    type: LOAD_EDIT_NEWS_DATA,
    payload: newsitem,
  };
}

export function openNewsModal(option) {
  return {
    type: OPEN_NEWS_MODAL,
    payload: option,
  };
}

export function updateNewsImage(image) {
  return {
    type: UPDATE_NEWS_IMAGE,
    payload: image,
  };
}

export function insertNews(session, values, newsitem, imagedata, callback) {
  var eventid = session.eventid;
  values = { ...values, eventid };

  if (imagedata) {
    imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");

    var filename = `eventify/${eventid}/images/news/${randomstring(32)}.jpg`;

    var imageJson = {
      resource: [
        {
          name: filename,
          type: "file",
          is_base64: true,
          content: imagedata,
        },
      ],
    };

    return (dispatch) => {
      uploadEncodedFile(
        `${BASE_IMAGES_URL}?check_exist=false`,
        session,
        imageJson,
        dispatch,
        (data) => {
          //debugger;
          var newsimage = data.path;
          values = { ...values, newsimage, newsthumbimage: data.path };
          // image is uploaded and filepath is appended
          // create / update news
          dispatch(_createUpdateNews(session, values, newsitem, callback));
        },
        (error) => {
          callback({ error: 2, data: error });
        }
      );
    };
  } else {
    return (dispatch) => {
      // if(!values.newsimage || values.newsimage==="")
      if (newsitem && newsitem.newsimage) {
        values = {
          ...values,
          newsimage: newsitem.newsimage,
          newsthumbimage: newsitem.newsthumbimage,
        };
      } else {
        values = { ...values, newsimage: "", newsthumbimage: "" };
      }
      dispatch(_createUpdateNews(session, values, newsitem, callback));
    };
  }
}

function _createUpdateNews(session, values, newsitem, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/news/`;

  return (dispatch) => {
    var successCallback = (data) => {
      dispatch(fetchNews(session, "", "", (callback) => {}));
      callback({ error: 0, data: data });
    };

    var errorCallback = (error) => {
      callback({ error: 1, data: error });
    };

    if (isEmpty(newsitem)) {
      postRequest(
        url,
        { resource: values, eventid: session.eventid },
        session,
        dispatch,
        successCallback,
        errorCallback
      );
    } else {
      var updateJson = {
        eventid: values.eventid,
        newscontent: values.newscontent,
        newstitle: values.newstitle,
        newsid: values.newsid,
        newsimage: values.newsimage,
        newsthumbimage: values.newsthumbimage,
      };
      patchRequest(
        url,
        {
          resource: {
            ...updateJson,
            newsitemid: newsitem.newsid,
            eventid: session.eventid,
          },
        },
        session,
        dispatch,
        successCallback,
        errorCallback
      );
    }
  };
}
